import { PublicRoutes } from "@/constants/routes";
import type { FAQItem } from "@/pages/landingPage/components";
import { HUB_CRUMB, webApplicationSchema } from "../constants";

export const PATH = PublicRoutes.FERRAMENTA_CALCULADORA_INADIMPLENCIA;
// Sem o sufixo "| Fidexa": o titleTemplate de src/App.tsx acrescenta.
export const TITLE = "Calculadora de Inadimplência do Crediário";
export const DESCRIPTION =
  "Calculadora de inadimplência grátis para lojas: descubra quanto do crediário próprio atrasa, quanto volta ao caixa e quanto sua loja perde a cada ano.";

export const TRAIL = [
  HUB_CRUMB,
  { name: "Calculadora de inadimplência", path: PATH },
];

export const WEB_APPLICATION = webApplicationSchema({
  name: "Calculadora de inadimplência do crediário",
  path: PATH,
  description: DESCRIPTION,
});

/**
 * Taxa média de recuperação da carteira na plataforma (big numbers da LP).
 * Decisão do founder: é o número a usar — fonte em
 * .claude/skills/seo/reference/fidexa-empresa.md.
 */
export const FIDEXA_RECOVERY_RATE = 0.321;

export const FAQ_ITEMS: FAQItem[] = [
  {
    question: "Como calcular a inadimplência do crediário da loja?",
    answer:
      "Some o valor das parcelas que venceram no período e não foram pagas e divida pelo valor total das parcelas que venceram no mesmo período. Se venceram R$ 100 mil no mês e R$ 12 mil ficaram em aberto, a inadimplência do mês é de 12%. Medir sempre pelo valor, e não pelo número de clientes, mostra o tamanho real do dinheiro parado.",
  },
  {
    question: "Qual é uma taxa de inadimplência comum no crediário próprio?",
    answer:
      "Depende do segmento e da região. Ao começar a cobrar uma loja, a Fidexa costuma encontrar inadimplência entre 15% e 30% ao ano, que pode chegar a 50% em determinados meses. No varejo de calçados, a CNDL e o SPC Brasil registraram índice de 9,53%, o maior do varejo nacional.",
  },
  {
    question:
      "De onde vem a taxa de recuperação de 32,10% usada na comparação?",
    answer:
      "É a taxa média de recuperação das carteiras cobradas pela Fidexa: a parte do valor em atraso que volta ao caixa do lojista depois da cobrança automática pelo WhatsApp. É uma média entre clientes; o resultado de cada loja varia com o perfil da carteira e com o tempo de atraso.",
  },
  {
    question: "Vale a pena cobrar parcelas atrasadas de valor baixo?",
    answer:
      "Vale, desde que a cobrança não custe mais que a dívida. Levar uma parcela pequena à Justiça raramente compensa; cobrar pelo WhatsApp, com lembrete, negociação e Pix na mesma conversa, roda no automático e não ocupa ninguém da equipe. É por isso que a Fidexa cobra dívidas a partir de R$ 50, que muitas lojas já davam como perdidas.",
  },
];
